export default class FilterOption {
  constructor(id, text) {
    this.id = id;
    this.text = text;
  }
}